var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75c-5.522 0-10 4.48-10 10 0 5.524 4.478 10 10 10 5.523 0 10-4.476 10-10 0-5.52-4.477-10-10-10zm0 4.435a1.694 1.694 0 110 3.388 1.694 1.694 0 010-3.388zm2.258 10.242a.484.484 0 01-.484.484h-3.548a.484.484 0 01-.484-.484v-.967c0-.268.217-.484.484-.484h.484v-2.58h-.484a.484.484 0 01-.484-.485v-.967c0-.268.217-.484.484-.484h2.58c.268 0 .484.216.484.483v4.033h.484c.267 0 .484.216.484.484v.967z",
    fill: "#1F67C9"
  })));
}

export default SvgInfoIcon;